import { createSlice } from '@reduxjs/toolkit'

export const tokenSlice = createSlice({
    name: 'token',
    initialState: {
        value: undefined
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = undefined;
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = tokenSlice.actions

export default tokenSlice.reducer